import { gql } from "@apollo/client";

export const GET_BOOKINGS_BY_ACCOUNTID = gql`
    query GetBookingsByAccountId($accountid: uuid!) {
        portal_accounts(where: { id: { _eq: $accountid } }) {
            number
            title
            credit
            debit
            bookings(order_by: { date: desc }, where: { cancellation: { _eq: false } }) {
                date
                debit
                credit
                text
                quantity
                documentnumber
                bookingfiles: v_bookingfiles(
                    order_by: { filedate: desc, fileid: desc }
                    distinct_on: [filedate, fileid]
                ) {
                    bookingfileid: id
                    fileid
                    name
                    filedate
                }
            }
        }
    }
`;

export const GET_TENANT_BOOKINGS_BY_USER = gql`
    query GetTenantBookingsByUser($realestateid: uuid!) {
        tenants: portal_v_tenantbookings_by_realestate(
            where: { realestateid: { _eq: $realestateid }, cancellation: { _eq: false } }
            distinct_on: tenantid
        ) {
            tenantid
            name
            accountbalance
        }
        tenantbookings: portal_v_tenantbookings_by_realestate(
            where: { realestateid: { _eq: $realestateid }, cancellation: { _eq: false } }
        ) {
            tenantid
            tenantbookingid
            date
            duedate
            documentnumber
            cancellation
            credit
            debit
            quantity
            text
            tenantbookingfiles: v_tenantbookingfiles(order_by: { filedate: desc, fileid: desc }) {
                id
                fileid
            }
        }
    }
`;

export const GET_TENANT_BOOKINGS_BY_USER_IT2 = gql`
    query GetTenantBookingsByUserIT2($realestateid: uuid!) {
        tenants: portal_v_tenantbookings_by_realestate(
            where: {
                _or: [{ realestateid: { _eq: $realestateid } }, { consolidationid: { _eq: $realestateid } }]
                _and: { cancellation: { _eq: false } }
            }
            distinct_on: tenantid
        ) {
            tenantid
            name
            accountbalance
        }
        tenantbookings: portal_v_tenantbookings_by_realestate(
            where: {
                _or: [{ realestateid: { _eq: $realestateid } }, { consolidationid: { _eq: $realestateid } }]
                _and: { cancellation: { _eq: false } }
            }
        ) {
            tenantid
            tenantbookingid
            date
            duedate
            documentnumber
            cancellation
            credit
            debit
            quantity
            text
            tenantbookingfiles: v_tenantbookingfiles(order_by: { filedate: desc, fileid: desc }) {
                id
                fileid
            }
        }
    }
`;
